module.exports = __webpack_public_path__ + "img/kate.2e841d33.jpg";